
// src/hooks/useAuthState.ts
import { useState } from "react";
import { User, Session } from "@supabase/supabase-js";

export function useAuthState() {
  const [user, setUser] = useState<User | null>(null);
  const [session, setSession] = useState<Session | null>(null);
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [organizationId, setOrganizationId] = useState<string | null>(null);
  const [subscriptionStatus, setSubscriptionStatus] = useState<string | null>(null);
  const [hasValidSubscription, setHasValidSubscription] = useState(false);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);

  return {
    user,
    session,
    userRole,
    isAdmin,
    organizationId,
    subscriptionStatus,
    hasValidSubscription,
    subscriptionLoading,
    setUser,
    setSession,
    setUserRole,
    setIsAdmin,
    setOrganizationId,
    setSubscriptionStatus,
    setHasValidSubscription,
    setSubscriptionLoading
  };
}
